import collinPic from "@/public/images/artists/collin.png";
import { Artist } from "@/types/types";

export const collin = {
  id: "28",
  name: "Collin",
  image: collinPic,
  description: `Introducing "Collin," the British pop sensation with a boundless vocal range. With a voice that effortlessly spans octaves, Collin brings a dynamic and captivating presence to the pop music scene.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fcollin-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "Dance", "Ballads"],
      secondary: ["Singer", "Versatile"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 52,
        high: 71,
      },
    },
  },
} as const satisfies Artist;
